export default {
    getImages(imagesObject, size) {
        Object.keys(imagesObject).map((key, index) => {
            const img = new Image();
            img.src = `${imagesObject[key].bg}/${size}`;
        });

        return new Promise(resolve => resolve(imagesObject));
    },
    preloadImages(imagesObject, size){
        return this.getImages(imagesObject, size)
    }
}
